import { UnitsBulkAssignView, UnitsReservationView  , ContactProfileManagementView} from '../../Views/Home';
import {
  UnitsLeaseView,
  UnitsLeaseManagementView,
  UnitsLeaseStatusManagementView,
  UnitsLeaseProfileManagementView,
} from '../../Views/Home/UnitsLeaseView';
import { DuplicatedUnitsView } from '../../Views/Home/UnitsView/DuplicatedUnits/DuplicatedUnitsView';

export const UnitsLeaseRoutes = [
  {
    path: '/add',
    name: 'homeLayout.unitsManagementView.units-management-view',
    component: UnitsLeaseManagementView,
    layout: '/home/units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'UnitsView:units',
        isDisabled: false,
        route: '/home/units-lease/view',
        groupName: 'leasing',
      },
      {
        name: 'homeLayout.unitsManagementView.units-management-view',
        isDisabled: true,
        route: '/home/units-lease/add',
      },
    ],
  },
  {
    path: '/edit',
    name: 'homeLayout.unitsManagementView.units-management-view',
    component: UnitsLeaseManagementView,
    layout: '/home/units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'UnitsView:units',
        isDisabled: false,
        route: '/home/units-lease/view',
        groupName: 'leasing',
      },
      {
        name: 'homeLayout.unitsManagementView.units-management-view',
        isDisabled: true,
        route: '/home/units-lease/edit',
      },
    ],
  },
  {
    path: '/unit-profile-edit',
    name: 'UnitsProfileManagementView:unit-profile-edit',
    component: UnitsLeaseProfileManagementView,
    layout: '/home/units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'unitsView:units',
        isDisabled: false,
        route: '/home/units-lease/view',
        groupName: 'leasing',
      },
      {
        name: 'UnitsProfileManagementView:unit-profile-edit',
        isDisabled: true,
        route: '/home/units-lease/unit-profile-edit',
      },
    ],
  },
  {
    path: '/unit-status-management',
    name: 'UnitsStatusManagementView:unit-status-management',
    component: UnitsLeaseStatusManagementView,
    layout: '/home/units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'unitsView:units',
        isDisabled: false,
        route: '/home/units-lease/view',
        groupName: 'leasing',
      },
      {
        name: 'UnitsStatusManagementView:unit-status-management',
        isDisabled: true,
        route: '/home/units-lease/unit-status-management',
      },
    ],
  },
  {
    path: '/view',
    name: 'UnitsView:units',
    component: UnitsLeaseView,
    layout: '/home/units-lease',
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'UnitsView:units',
        isDisabled: false,
        route: '/home/units-lease/view',
        groupName: 'leasing',
      },
    ],
  },
  {
    path: '/unit-profile-reservation',
    name: 'UnitsProfileManagementView:unit-profile-reservation',
    component: UnitsReservationView,
    layout: '/home/units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'unitsView:units',
        isDisabled: false,
        route: '/home/units-lease/view',
        groupName: 'leasing',
      },
      {
        name: 'UnitsProfileManagementView:unit-profile-reservation',
        isDisabled: true,
        route: '/home/units-sales/unit-profile-reservation',
      },
    ],
  },
  {
    path: '/unit-bulk-update',
    name: 'UnitsProfileManagementView:unit-bulk-update',
    component: UnitsBulkAssignView,
    layout: '/home/units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'unitsView:units',
        isDisabled: false,
        route: '/home/units-lease/view',
        groupName: 'leasing',
      },
      {
        name: 'UnitsProfileManagementView:unit-bulk-update',
        isDisabled: true,
        route: '/home/units-sales/unit-bulk-update',
      },
    ],
  },
  {
    path: '/contact-edit',
    name: 'ContactProfileManagementView:contact-profile-edit',
    component: ContactProfileManagementView,
    layout: '/home/units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'unitsView:units',
        isDisabled: false,
        route: '/home/units-lease/view',
        groupName: 'leasing',
      },
      {
        name: 'ContactProfileManagementView:contact-profile-edit',
        isDisabled: true,
        route: '/home/units-lease/contact-edit',
      },
    ],
  },
  
  {
    path: '/duplicated-units',
    name: 'UnitsView:duplicated-units',
    component: DuplicatedUnitsView,
    layout: '/home/units-lease',
    default: false,
    isRoute: true,
    authorize: true,
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'UnitsView:units',
        isDisabled: false,
        route: '/home/units-lease/view',
        groupName: 'leasing',
      },
      {
        name: 'ContactProfileManagementView:duplicated-units',
        isDisabled: false,
        route: '/home/units-lease/duplicated-units',
      },
    ],
  },
];
